// Interest Context
export const ON_FORM_DATA_CHANGE = "ON_FORM_DATA_CHANGE";
export const GET_SITE_INFORMATION = "GET_SITE_INFORMATION";
export const GET_BRAND_SITE = "GET_BRAND_SITE";
export const GET_SITE_PROGRAM = "GET_SITE_PROGRAM";
export const ON_ZIP_SEARCH_CHANGE = "ON_ZIP_SEARCH_CHANGE";
export const SET_LOADING = "SET_LOADING";
export const GET_ZIP_SITES = "GET_ZIP_SITES";
export const LEVEL_UP = "LEVEL_UP";
export const LEVEL_DOWN = "LEVEL_DOWN";
export const GET_AGE = "GET_AGE";
export const SET_PASS = "SET_PASS";
export const SUBMIT_DATA = "SUBMIT_DATA";
export const GET_SCHOOLTYPESFORWEB = "GET_SCHOOLTYPESFORWEB";
export const GET_PROGRAMTYPESFORWEB = "GET_PROGRAMTYPESFORWEB";
export const APPLY_FILTER = "APPLY-FILTER";
export const GET_BRAND_DATA = "GET_BRAND_DATA";
export const RESET_INTEREST_FORM = "RESET_INTEREST_FORM";
export const GET_LELO_DATA = "GET_LELO_DATA";
export const ADD_NOTES = " ADD_NOTES";
export const GET_INTERESTNOTES = "GET_INTERESTNOTES";
export const GET_LELO_COURSES_PERMALINK = "GET_LELO_COURSES_PERMALINK";
export const GET_LELO_SESSION = "GET_LELO_SESSION";
export const GET_LELO_SESSION1 = "GET_LELO_SESSION1";
export const GET_LELOENTRIES_OPTIMIZED = "GET_LELOENTRIES_OPTIMIZED";
export const SET_LOADING_OPTIMIZED = "SET_LOADING_OPTIMIZED";
export const GET_LELOENTRIES_OPTIMIZED_ZIP = "GET_LELOENTRIES_OPTIMIZED_ZIP";

// Admin Context
export const GET_ENROLLMENT_SITES = "GET_ENROLLMENT_SITES";
export const FILTER_ENROLLMENT_SITES = "FILTER_ENROLLMENT_SITES";
export const CLEAR_FILTER_ENROLLMENT_SITES = "CLEAR_FILTER_ENROLLMENT_SITES";
export const GET_ENTRIES = "GET_ENTRIES";
export const GET_ENTRIE = "GET_ENTRIE";
export const GET_ENTRIE_UUID = "GET_ENTRIE_UUID";
export const CLEAR_ENTRIE = "CLEAR_ENTRIE";
export const UPDATE_ENTRIE = "UPDATE_ENTRIE";
export const DELETE_ENTRIE = "DELETE_ENTRIE";
export const GET_REGISTRATIONS = "GET_REGISTRATIONS";
export const GET_LELOREGISTRATIONS = "GET_LELOREGISTRATIONS";
export const GET_COURSECATALOG = "GET_COURSECATALOG";
export const ADD_LELO = "ADD_LELO";
export const UPDATE_LELO = "UPDATE_LELO";
export const GET_COURSEOPTIONCATALOG = "GET_COURSEOPTIONCATALOG";
export const GET_COURSEOPTIONCATALOGID = "GET_COURSEOPTIONCATALOGID";
export const SEARCH_FILTERLELO = " SEARCH_FILTERLELO";
export const CLEAR_SEARCH_FILTERLELO = "CLEAR_SEARCH_FILTERLELO";
export const GET_REGISTRATION = "GET_REGISTRATION";
export const CLEAR_REGISTRATION = "CLEAR_REGISTRATION";
export const UPDATE_REGISTRATION = "UPDATE_REGISTRATION";
export const DELETE_REGISTRATION = "DELETE_REGISTRATION";
export const AGE_FILTER = "AGE_FILTER";
export const SEARCH_FILTER = "SEARCH_FILTER";
export const CLEAR_AGE_FILTER = "CLEAR_AGE_FILTER";
export const CLEAR_SEARCH_FILTER = "CLEAR_SEARCH_FILTER";
export const SET_LIST_VIEW = "SET_LIST_VIEW";
export const FILTER_TABLE = "FILTER_TABLE";
export const FILTER_REGISTRATION_TABLE = "FILTER_REGISTRATION_TABLE";
export const CLEAR_FILTER_TABLE = "CLEAR_FILTER_TABLE";
export const SET_FORM_MODAL = "SET_FORM_MODAL";
export const CLEAR_NOTINTEREST_FILTER = "CLEAR_NOTINTEREST_FILTER";
export const NOTINTEREST_FILTER = " NOTINTEREST_FILTER";
export const GET_TRANSFER_REGISTRATIONS = "GET_TRANSFER_REGISTRATIONS";
export const TRANSFER_FILTER = " TRANSFER_FILTER";
export const CLEAR_TRANSFER_FILTER = "CLEAR_TRANSFER_FILTER";

//LeloContext
export const GET_LELOENTRIES = "GET_LELOENTRIES";
export const GET_ENROLLMENT_ENTRIES = "GET_ENROLLMENT_ENTRIES";
export const GET_INTENTRIES_OPTIMIZED = "GET_INTENTRIES_OPTIMIZED";
export const GET_LELOENTRIE = "GET_LELOENTRIE";
export const UPDATE_LELOENTRIE = " UPDATE_LELOENTRIE";
export const  CLEAR_LELOENTRIE=" CLEAR_LELOENTRIE";
export const INACTIVE_FILTER="INACTIVE_FILTER";
export const  CLEAR_INACTIVE_FILTER="CLEAR_INACTIVE_FILTER"
export const SESSION_FILTER = "SESSION_FILTER";
export const CLEAR_SESSION_FILTER = "CLEAR_SESSION_FILTER";
export const GET_LELO_COURSES="GET_LELO_COURSES";
export const ACTIVE_FILTER ="ACTIVE_FILTER";
export const SIGNED_FILTER ="SIGNED_FILTER";
export const GET_LELO_COURSES_CHARTERID="GET_LELO_COURSES_CHARTERID";
export const GET_LELO_DATA_UUID="GET_LELO_DATA_UUID";
export const FILTER_BY_DATE= "FILTER_BY_DATE";
export const CLEAR_DATE_FILTER="CLEAR_DATE_FILTER";

// Auth Context
export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const SOCIAL_LOGIN_SUCCESS = "SOCIAL_LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const GET_PROGRAMTYPES="GET_PROGRAMTYPES";
export const STORE_NAVIGATION_STATE = 'STORE_NAVIGATION_STATE';
export const RESTORE_NAVIGATION_STATE = 'RESTORE_NAVIGATION_STATE';
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';

// Registration Pagination
export const GET_REGISTRATION_ENTRIES = "GET_REGISTRATION_ENTRIES";
export const SET_LOADING_REG = "SET_LOADING_REG";